import {
  Entity,
  Column,
  PrimaryColumn,
  CreateDateColumn,
  UpdateDateColumn,
  ManyToOne,
  JoinColumn,
} from 'typeorm';
import { UserRole, UserStatus, UserPosition } from '../../interface/users/users-response.interface';
import { AttachmentsEntity } from '../attachments/attachments.entity';

@Entity('users')
export class UsersEntity {

  @PrimaryColumn('uuid')
  id!: string;

  @Column({ unique: true })
  email!: string;

  @Column({ type: 'varchar' })
  role!: UserRole;

  @Column({ type: 'varchar' })
  status!: UserStatus;

  @Column({ type: 'varchar' })
  position?: UserPosition;

  @Column({ nullable: true })
  first_name?: string;

  @Column({ nullable: true })
  last_name?: string;

  @Column({ nullable: true })
  phone_number?: string;

  @CreateDateColumn()
  created_at?: Date;

  @UpdateDateColumn()
  updated_at?: Date;

  // self reference (creator)
  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'created_by' })
  created_by?: UsersEntity;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by' })
  updated_by?: UsersEntity;

  @ManyToOne(() => AttachmentsEntity, { nullable: true })
  @JoinColumn({ name: 'attachment_signature_id' })
  attachment_signature?: AttachmentsEntity;

  @ManyToOne(() => AttachmentsEntity, { nullable: true })
  @JoinColumn({ name: 'attachment_avatar_id' })
  attachment_avatar?: AttachmentsEntity;
}